var render = function () {
  var _vm$question;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "question"
  }, [_c('ColorAvatar', {
    staticClass: "question__avatar",
    attrs: {
      "size": "60",
      "mobile-size": "40",
      "name": _vm.question.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "question__complain"
  }, [_c('span', {
    staticClass: "link-icon link-icon_grey link-icon_dashed fz-14 question__pointer",
    on: {
      "click": _vm.onClickReport
    }
  }, [_c('div', {
    staticClass: "link-icon__icon-warning"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "question__content"
  }, [_c('div', {
    staticClass: "question__title-row"
  }, [_c('div', {
    staticClass: "question__title"
  }, [_vm._v("\n        " + _vm._s(_vm.question.name) + "\n      ")]), _vm._v(" "), _vm.question.date ? _c('div', {
    staticClass: "question__date p p_grey"
  }, [_vm._v("\n        " + _vm._s(_vm.getCurrentDate((_vm$question = _vm.question) === null || _vm$question === void 0 ? void 0 : _vm$question.date)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "question__text p"
  }, [_vm._v("\n      " + _vm._s(_vm.question.text) + "\n    ")]), _vm._v(" "), _c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var onClick = _ref.onClick,
            isActive = _ref.isActive;
        return [_c('div', {
          staticClass: "question__tools"
        }, [_c('div', {
          staticClass: "question__tool"
        }, [_vm.question.answer && _vm.question.answer.length ? [_c('div', {
          staticClass: "icon-comment"
        }), _vm._v(" "), _c('span', {
          staticClass: "question__comment-count"
        }, [_vm._v(_vm._s(_vm.question.answer.length))])] : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "question__button",
          attrs: {
            "data-e2e": "question-comment-button"
          },
          on: {
            "click": onClick
          }
        }, [_vm._v("Ответить")])], 2), _vm._v(" "), _c('div', {
          staticClass: "question__tool"
        }, [_c('UIActionList', {
          attrs: {
            "actions": {
              like: _vm.$api.question.like,
              dislike: _vm.$api.question.dislike
            }
          },
          on: {
            "like:success": function ($event) {
              return _vm.onClickThumbs($event, 'like');
            },
            "dislike:success": function ($event) {
              return _vm.onClickThumbs($event, 'dislike');
            },
            "like:error": _vm.onError,
            "dislike:error": _vm.onError
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var like = _ref2.like,
                  dislike = _ref2.dislike;
              return [_c('ReviewsThumbs', {
                attrs: {
                  "like": _vm.likes,
                  "dislike": _vm.dislikes,
                  "active-like": _vm.activeLike,
                  "active-dislike": _vm.activeDislike
                },
                on: {
                  "positive": function ($event) {
                    return like.request({
                      id: _vm.question.id
                    });
                  },
                  "negative": function ($event) {
                    return dislike.request({
                      id: _vm.question.id
                    });
                  }
                }
              })];
            }
          }], null, true)
        })], 1)]), _vm._v(" "), isActive ? _c('div', {
          staticClass: "question__response"
        }, [_c('UIActionEntity', {
          attrs: {
            "get": _vm.$api.question.addComment
          },
          on: {
            "success": function ($event) {
              return _vm.emit('add-answer', _vm.question.id, $event.response);
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var get = _ref3.get,
                  status = _ref3.status,
                  error = _ref3.error;
              return [_c('AnswerForm', {
                attrs: {
                  "parent-id": _vm.question.id,
                  "user-name": _vm.question.name,
                  "product-id": _vm.productId,
                  "status": status,
                  "error": error
                },
                on: {
                  "send": function ($event) {
                    get($event), _vm.$emitter.emit('submit-form-data', {
                      email: $event.email
                    });
                  }
                }
              })];
            }
          }], null, true)
        })], 1) : _vm._e()];
      }
    }])
  }), _vm._v(" "), _vm.question.answer && _vm.question.answer.length ? _c('div', {
    staticClass: "question__responses"
  }, _vm._l(_vm.question.answer, function (comment) {
    return _c('CommentaryQuestion', {
      key: comment.id,
      attrs: {
        "product-id": _vm.productId,
        "question-id": _vm.question.id,
        "comment": comment
      },
      on: {
        "report": function ($event) {
          return _vm.enableReport(_vm.productId);
        }
      },
      scopedSlots: _vm._u([{
        key: "answer",
        fn: function (answer) {
          return [_c('UIActionEntity', {
            attrs: {
              "get": _vm.$api.question.addComment
            },
            on: {
              "success": function ($event) {
                return _vm.emit('add-answer', answer.parentId, $event.response);
              }
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (_ref4) {
                var get = _ref4.get,
                    status = _ref4.status,
                    error = _ref4.error;
                return [_c('AnswerForm', {
                  attrs: {
                    "parent-id": answer.parentId,
                    "user-name": answer.comment,
                    "product-id": _vm.productId,
                    "status": status,
                    "error": error
                  },
                  on: {
                    "send": function ($event) {
                      get($event), _vm.$emitter.emit('submit-form-data', {
                        email: $event.email
                      });
                    }
                  }
                })];
              }
            }], null, true)
          })];
        }
      }], null, true)
    });
  }), 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }